import { useTranslation } from 'react-i18next';
import {
  Button,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { ReleaseIcon } from 'assets/icons';
import { selectReleaseRequest } from 'services/store/distribution/selectors';
import ReleaseIconButton from './ReleaseIconButton';

type Props = {
  songId: string;
  onClick?: () => void;
};

const ReleaseButton = ({ songId, onClick }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const releaseRequest = useSelector(selectReleaseRequest(songId));
  const isLoading = releaseRequest?.loading;

  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  if (isMobile) {
    return <ReleaseIconButton songId={songId} />;
  }

  return (
    <Button
      variant="outlined"
      startIcon={
        isLoading ? (
          <CircularProgress
            sx={{ color: theme.palette.grey[50] }}
            size={theme.spacing(3)}
          />
        ) : (
          <ReleaseIcon />
        )
      }
      disabled={isLoading}
      sx={{
        width: '100%',
        borderColor: theme.palette.grey[50],
        borderRadius: theme.spacing(3),
        textTransform: 'none',
        color: theme.palette.grey[50],
        '&:hover': {
          borderColor: theme.palette.grey[100],
        },
      }}
      onClick={onClick}
    >
      <Typography
        sx={{
          color: theme.palette.grey[50],
          fontSize: 12,
          fontWeight: 500,
        }}
      >
        {t('distribution:release')}
      </Typography>
    </Button>
  );
};

export default ReleaseButton;
